export default __webpack_public_path__ + "static/media/something.25619a4e.svg";